import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { WatchListDataTypes } from "./types"

export interface GetWatchlistPropertiesResponseData extends ResponseData {
  data: {
    watchList: WatchListDataTypes[]
  }
}

export interface GetWatchlistPropertiesResponse extends AxiosResponse {
  data: GetWatchlistPropertiesResponseData
}

export interface WatchlistPropertiesRequest {
  params: {
    favouriteListId: number | string
  }
}
export function getWatchListPropertiesApi(
  { params }: WatchlistPropertiesRequest,
  axiosInstance: AxiosInstance,
): Promise<GetWatchlistPropertiesResponse> {
  return axiosInstance({
    params,
    method: "get",
    url: "/property/get-watchlist-properties",
  }) as Promise<GetWatchlistPropertiesResponse>
}
